import React, { useContext, useEffect, useState, useRef } from "react";
import { Form, Row, Col, Button, Container } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import { UserConsumer, UserContext } from "../../../../../UserContext";
import axios from "axios";
import { ItemRequisitionAPI } from "../../ItemRequisitionAPI";
import CustomReactSelect from "../../../../../components/CustomReactSelect";
import DatePicker from "react-datepicker";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Redirect, useHistory, useParams } from "react-router-dom";
import moment from "moment";
import Header from "../../../../../components/Header";
import { AlertPopups } from "../../../../../components/AlertPopups";
import { Routes } from "../../../../../configurations/config";

const CreateNewVendor = () => {
	const { token } = useContext(UserContext);
	const [categoriesList, setCategoriesList] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [validDate, setValidDate] = useState(new Date());
	const { vendorId } = useParams();
	const history = useHistory();
	const [vendor, setVendor] = useState({
		name: "",
		phone: "",
		phone2: "",
		email: "",
		primaryContact: "",
		address: "",
		details: "",
		status: false,
		vendorStatus: "Approved",
	});
	const DatepickerRef = useRef(null);
	const statusOption = [
		{ label: "Approved", value: 1 },
		{ label: "Not Approved", value: 2 },
	];

	useEffect(() => {
		axios
			.get(`${ItemRequisitionAPI.GetCategories}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data, headers }) => {
				setCategoriesList(data["categories"]);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
		if (vendorId) {
			axios
				.get(
					`${ItemRequisitionAPI.GetItemRequisitionVendor}/${vendorId}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((res) => {
					setVendor({
						name: res.data.name,
						phone: res.data.phone ? res.data.phone : "",
						phone2: res.data.phone2 ? res.data.phone2 : "",
						email: res.data.email ? res.data.email : "",
						primaryContact: res.data.primaryContact
							? res.data.primaryContact
							: "",
						address: res.data.address ? res.data.address : "",
						details: res.data.details ? res.data.details : "",
						status: res.data.status,
						vendorStatus: res.data.approved
							? "Approved"
							: "Not Approved",
					});
					setValidDate(
						res.data.validUpTo ? new Date(res.data.validUpTo) : null
					);
					setSelectedCategories(res.data.categories);
				});
		}
	}, []);
	const handleChange = (e) => {
		setVendor({ ...vendor, [e.target.name]: e.target.value });
	};

	const handleSubmit = () => {
		if (!vendor.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Name Cannot be Empty",
			});

			return;
		}
		if (!vendor.phone) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Phone Cannot be Empty",
			});

			return;
		}
		if (!vendor.email) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Email Cannot be Empty",
			});

			return;
		}
		if (!vendor.email) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Email Cannot be Empty",
			});

			return;
		}
		if (!vendor.primaryContact) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Primary Contact Cannot be Empty",
			});

			return;
		}
		if (selectedCategories.length === 0) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Categories Cannot be Empty",
			});

			return;
		}
		if (!vendor.address) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor address Cannot be Empty",
			});

			return;
		}
		const body = {
			name: vendor.name,
			details: vendor.details,
			phone: vendor.phone,
			phone2: vendor.phone2,
			email: vendor.email,
			fax: "1223231",
			address: vendor.address,
			status: vendor.status,
			approved: vendor.vendorStatus === "Approved" ? true : false,
			primaryContact: vendor.primaryContact,
			categoryIds: selectedCategories.map((item) => item.value),
			validUpTo: moment(validDate).format("YYYY-MM-DD HH:mm:ss"),
		};
		axios
			.post(`${ItemRequisitionAPI.GetItemRequisitionVendor}`, body, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(() => {
				AlertPopups.successAlert.fire({
					text: "Vendor has been Created Successfully",
				});

				history.push(Routes.ItemRequisitionVendors);
			})
			.catch((e) => {
				AlertPopups.ErrorAlert.fire({
					text: `${e.response.data.message}`,
				});
			});
	};

	const handleUpdate = () => {
		if (!vendor.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Name Cannot be Empty",
			});

			return;
		}
		if (!vendor.phone) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Phone Cannot be Empty",
			});

			return;
		}
		if (!vendor.email) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Email Cannot be Empty",
			});

			return;
		}
		if (!vendor.email) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Email Cannot be Empty",
			});

			return;
		}
		if (!vendor.primaryContact) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Primay Contact Cannot be Empty",
			});

			return;
		}
		if (selectedCategories.length === 0) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Categories Cannot be Empty",
			});

			return;
		}
		if (!vendor.address) {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Address Cannot be Empty",
			});

			return;
		}
		if (vendor.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Vendor Name Cannot be Empty",
			});
		}
		const body = {
			name: vendor.name,
			details: vendor.details,
			phone: vendor.phone,
			phone2: vendor.phone2,
			email: vendor.email,
			fax: "1223231",
			address: vendor.address,
			status: vendor.status,
			approved: vendor.vendorStatus === "Approved" ? true : false,
			primaryContact: vendor.primaryContact,
			categoryIds: selectedCategories.map((item) => item.value),
			validUpTo: moment(validDate).format("YYYY-MM-DD HH:mm:ss"),
		};
		axios
			.put(
				`${ItemRequisitionAPI.GetItemRequisitionVendor}/${vendorId}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(() => {
				AlertPopups.successAlert.fire({
					text: "Vendor has been Created Successfully",
				});

				history.push(Routes.ItemRequisitionVendors);
			})
			.catch((e) => {
				AlertPopups.ErrorAlert.fire({
					text: `${e.response.data.message}`,
				});
			});
	};
	const openDatepicker = () => {
		const datepickerElement = DatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="pt-3">
						<Header
							title={vendorId ? "Update Vendor" : "Create Vendor"}
							headerBorder="true"
							navigateBack={() =>
								history.push(Routes.ItemRequisitionVendors)
							}
						/>
						<Form className="item-requisition-classes-form">
							<Label className="formInfoContainerHeader">
								{vendorId
									? "Update Vendor Details"
									: "Add Vendor Details"}
							</Label>
							<Row className="d-flex align-items-center item-requisition-classes-fbody">
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Name
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="text"
											name="name"
											value={vendor.name}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Phone
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="tel"
											name="phone"
											value={vendor.phone}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Phone2
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="tel"
											name="phone2"
											value={vendor.phone2}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Email
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="email"
											name="email"
											value={vendor.email}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Primary Contact
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="text"
											value={vendor.primaryContact}
											name="primaryContact"
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Address
											<span className="required">*</span>
										</Form.Label>
										<Input
											type="textarea"
											name="address"
											value={vendor.address}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Details
										</Form.Label>
										<Input
											type="textarea"
											name="details"
											value={vendor.details}
											onChange={handleChange}
											className="category-inputs h-auto formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Select Categorries
											<span className="required">*</span>
										</Form.Label>
										<CustomReactSelect
											className="multi-select category-inputs h-auto"
											placeholder="Select Categories"
											multipule={true}
											name="categories formValueInput"
											onChange={(value, event) =>
												setSelectedCategories(value)
											}
											value={selectedCategories}
											options={categoriesList}
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Vendor Status
										</Form.Label>
										<CustomReactSelect
											className="classes-select h-auto select-width formValueInput"
											placeholder="Please select an option"
											options={statusOption}
											value={statusOption.filter(
												(item) =>
													item.label ===
													vendor.vendorStatus
											)}
											onChange={(val) => {
												setVendor({
													...vendor,
													vendorStatus: val.label,
												});
											}}
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group">
										<Form.Label className=" emg-Contact-Info">
											Valid Upto
											<span className="required">*</span>
										</Form.Label>
										<Col
											className="datepicker-wrapper"
											style={{
												padding: "0",
												maxWidth: "60%",
											}}
										>
											<DatePicker
												showYearDropdown
												showMonthDropdown
												dateFormatCalendar=" " //for title
												name="startDate"
												className="custom-container formValueInput"
												onChange={(date) => {
													setValidDate(date);
												}}
												selected={validDate}
												value={validDate}
												dateFormat="dd/MM/yyyy"
												autoComplete="off"
												clearIcon={null}
												calendarIcon={null}
												minDate={new Date()}
												ref={DatepickerRef}
											/>
											<FontAwesomeIcon
												icon={faCalendarAlt}
												className="calender"
												color="keppel"
												style={{ right: "15px" }}
												onClick={() => openDatepicker()}
											/>
										</Col>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group
										className="category-form-group"
										style={{ justifyContent: "flex-start" }}
									>
										<Form.Label className="emg-Contact-Info ">
											Active
										</Form.Label>
										<Form.Control
											className="vendor-check"
											type="checkbox"
											checked={vendor.status}
											onChange={() => {
												setVendor({
													...vendor,
													status: !vendor.status,
												});
											}}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									{!vendorId ? (
										<Button
											className="classes-saveBtn"
											onClick={handleSubmit}
										>
											Save
										</Button>
									) : (
										<Button
											className="classes-saveBtn"
											onClick={handleUpdate}
										>
											Update
										</Button>
									)}
								</Col>
							</Row>
						</Form>
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default CreateNewVendor;
